import angular from 'angular';

import EquipmentNotificationsService from './EquipmentNotificationsService';
import EquipmentNotificationsComponent from './EquipmentNotificationsComponent';
import AlertPolicyModalComponent from './alertPolicyModal/AlertPolicyModalComponent';
import EquipmentLogsComponent from './equipmentLogs/EquipmentLogsComponent';

export default angular
  .module('petroCloud.admin.equipmentNotifications', [])
  .service('EquipmentNotificationsService', EquipmentNotificationsService)
  .component(EquipmentNotificationsComponent.name, EquipmentNotificationsComponent)
  .component(AlertPolicyModalComponent.name, AlertPolicyModalComponent)
  .component(EquipmentLogsComponent.name, EquipmentLogsComponent)
  .name;
